<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12">
          <v-select
            v-model="searchParams.region"
            :hint="lang($store, 'sap/listings.global.filter.hints.region')"
            :items="regionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
/* mixins */
import regionsFilter from '@/mixins/filters/regionsFilter';

/* components */
import isComponentLoading from '../../mixins/isComponentLoading';

export default {
  name: 'FilterOrderPricing',
  mixins: [
    isComponentLoading,
    regionsFilter,
  ],
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        region: null,
      }),
    },
  },
  data() {
    return {
      searchParams: {},
      menuFrom: false,
      menuTo: false,
    };
  },
  mounted() {
    this.searchParams = {
      region: null,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    getCurrentLocale() {
      return window.localStorage.language;
    },
  },
};
</script>

<style scoped>

</style>
